export function getBundleHashName() {
    return process.env.bundleHashName;
}

export function getBundleDate() {
    return process.env.bundleDate;
}

export function getDisabledIntercom() {
    return process.env.DISABLE_INTERCOM;
}

export function isProductionEnv() {
    return import.meta.env.MODE === 'production';
}

export function isDevelopmentEnv() {
    return import.meta.env.MODE === 'development';
}

export function isTestEnv() {
    return import.meta.env.MODE === 'test';
}

export function isStorybookEnv() {
    return !!window.STORYBOOK_ENV;
}

export function isSandboxEnv() {
    return window.ENVIRONMENT === 'sandbox';
}
